import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '~/components/atoms/button/button';
import styles from './cancelAllFiltersButton.module.scss';

interface ICancelFilters {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const CancelAllFiltersButton: React.FC<ICancelFilters> = ({ onClick }) => {
    return (
        <div className={styles.filterCancel}>
            <Button
                onclick={onClick}
                link={true}
                small={true}
                gray={true}
                data-testid="filters-cancel-all-filters-button"
            >
                <FormattedMessage id="cancel_filters" defaultMessage="Zrušit vybrané parametry" />
            </Button>
        </div>
    );
};

export default CancelAllFiltersButton;
